import actions from './actions';

const initState = {
  loading: false,
  message: null,
  buttonLoading: false,
  error: null,
  complaintsData: {},
  totalData: null,
  show: false
};


export default function authReducer(state = initState, action) {
  switch (action.type) {

    case actions.GET_COMPLAINTS_DATA:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_COMPLAINTS_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        complaintsData: action.payload.data,
        totalData: action.payload.totalData
      };
    case actions.GET_COMPLAINTS_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }

}
